module.exports = __webpack_public_path__ + "media/assets/images/number-plate-white-74af92bc03e11ffd2d997e29034e0584.png";